/**
 * Change styles to owl carousel.
 */
 function owl_carousel(){
    const elements = document.querySelectorAll(".owl-carousel-slider-container");    
    if (elements.length) {
        elements.forEach(function (element) {
            $(element).owlCarousel({
                items: 1,
                rewind: true,
                autoplay: true,
                autoplaySpeed: 500,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                dots: false,
            });
        });
    }
}

owl_carousel();

export default owl_carousel;